import { useParams } from 'react-router-dom'
import GradingFormScales from './Scales'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { retrieve } from 'store/settings/grading-scale'

export default function GradingFormIndex() {
  const dispatch = useDispatch()

  const { type, id } = useParams()
  const courseLevel = useSelector(state => state?.lookup?.courseLevel)

  const [data, setData] = useState()

  const getScaleDetail = async () => {
    await dispatch(retrieve({ id })).then(response => {
      setData(response.payload)
    })
  }

  useEffect(() => {
    if (+id && type === 'scales') {
      getScaleDetail()
    }
  }, [id])

  if (+id && type === 'scales' && !data) return null  // Skeleton

  // TODO: This page was beign hidden for the time being, if it is needed in the future, 'coefficient' parameter won't come, it should be handled properly 
  if (+id && type === 'coefficient' && !courseLevel) return null // Skeleton

  if (type === 'scales') return <GradingFormScales data={data || null} getScaleDetail={getScaleDetail} />
}
